// Func = limiting Scope for this file
document.addEventListener("DOMContentLoaded", DOMReady);
let lastScrollTop = 0;
(function(){

	$(document).ready(function () {

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});



		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date)
		});

	
		//Insert svg animate
		let itemMenu = document.querySelectorAll('.privary-navigation__item > a');
		itemMenu.forEach(function (i) {
			let txtItemMenu = i.innerHTML;
			let strokeText = '<svg class="title"><text x="50%" y="50%">' + txtItemMenu + '</text></svg>';
			i.insertAdjacentHTML('beforeend', strokeText);
		});
		if ($(window).width() > 767) {
			let itemTitle = document.querySelectorAll('.jsTitle');

			itemTitle.forEach(function (i) {
				let txtItemTitle = i.innerHTML.trim();
				let wordCount = txtItemTitle.split(' ').length;

				let strokeTitle = '';

				if (wordCount === 9) {
					let shortTitleOne = txtItemTitle.slice(0, 26);
					let shortTitleTwo = txtItemTitle.slice(26, 59);

					strokeTitle = `
						<svg class="title" xmlns="http://www.w3.org/2000/svg">
							<text x="50%" y="50%" text-anchor="middle" dominant-baseline="middle">
								<tspan x="23%" dy="-0.4em">${shortTitleOne}</tspan>
								<tspan x="25%" dy="1.0em">${shortTitleTwo}</tspan>
							</text>
						</svg>
					`;
				} else {
					// Si no tiene 6 palabras, solo inserta el texto completo
					strokeTitle = `
						<svg class="title" xmlns="http://www.w3.org/2000/svg">
							<text x="50%" y="50%" text-anchor="middle" dominant-baseline="middle">
								${txtItemTitle}
							</text>
						</svg>
					`;
				}

				i.insertAdjacentHTML('beforeend', strokeTitle);
			});
		}

		// Rellax
		let rellax = new Rellax('.rellax');
	
	});

	window.onload = function() {
		/* Initialize Parallax Lybrary */
		let istouch = document.querySelector('.mod-no-touchevents')
		if( $(window).width() > 767 ){
			if(istouch){
				var sk = skrollr.init();
			}
		}

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
	
	// Animated Number Counter To Value - TODO: Refactor vanilla
	let scrollTemp = document.documentElement.scrollTop;
	const $intro = document.getElementById('intro');
	let stop = false;
}

// Dom Ready Funtion
function DOMReady() {

	//Hover state btn
		$('.hoveredAction')
		.on('mouseenter', function(e) {
				var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
				$(this).find('span.hoveredState').css({top:relY, left:relX})
		})
		.on('mouseout', function(e) {
				var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find('span.hoveredState').css({top:relY, left:relX})
		});
	//End Hover state btn


	//CTA Scroll down to the bottom Intro
	const links = document.querySelectorAll(".arrow-hero a");
	for (const link of links) {
		link.addEventListener("click", clickHandler);
	}
	function clickHandler(e) {
		e.preventDefault();
		const href = this.getAttribute("href");
		const offsetTop = document.querySelector(href).offsetTop;
		scroll({
			top: offsetTop,
			behavior: "smooth"
		});
	}
	//End CTA Scroll down to the bottom Intro

	//Click for Menu
	[].forEach.call( document.querySelectorAll( '.menu-cta-js' ), function ( a ) {
		a.addEventListener( 'click', function ( e ) {
		if(!this.classList.contains('open')){
			this.parentElement.classList.add('open');
			this.classList.add('open');
			document.getElementById('menu-text-js').innerHTML = "close";
			document.getElementById('main-menu').classList.add('open');
			document.getElementById('header').classList.add('open-menu');
			document.querySelector("body").classList.add('noScroll');

		} else {
			this.classList.remove('open');
			this.parentElement.classList.remove('open');
			document.getElementById('menu-text-js').innerHTML = "menu";
			document.getElementById('main-menu').classList.remove('open');
			document.getElementById('header').classList.remove('open-menu');
			document.querySelector("body").classList.remove('noScroll')
		}
			e.preventDefault();
		}, false );
	});

	//email signup animation 
	if(document.getElementById('email-signup_email_address') || document.getElementById('email-signup_email_address')){
		document.getElementById('email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.getElementById('email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
	}
	//Form Contact animation 
    function attachEvents(elementList, eventName, handlerFunction) {
		if(typeof elementList == "string")
				elementList = document.querySelectorAll(elementList);
		for(var i = 0; i < elementList.length; i++)
				elementList[i].addEventListener(eventName, handlerFunction);
	}
	attachEvents(".form-module-wrapper input", "click", function(event) {
			this.parentElement.classList.add('moved');
	});
	attachEvents(".form-module-wrapper textarea", "click", function(event) {
			this.parentElement.classList.add('moved');
	});



}